import React from 'react';
import Agents from '../Agents/Agents';
import Banner from '../Banner/Banner';
import Cost from '../Cost/Cost';
import Pricing from '../Pricing/Pricing';
import Services from '../Services/Services';
import ShippingSolution from '../ShippingSolution/ShippingSolution';

const Home = () => {
    return (
        <div>
            <Banner />
            <ShippingSolution/>
            <Services />
            <Agents />
            <Pricing />
            <Cost/>
        </div>
    );
};

export default Home;